<template>
	<div>
		<!-- backurl="/pEdit_sku" -->
		<CubePage type="myorder-view" title="设置" backurl="/pEdit_sku">
			<div slot="content" class="content">
				<van-form v-model="entity" style="padding: 0;" @submit="onCommit">
					<van-field v-model="entity.buyNumMax" type="digit" label="最多购买" clearable placeholder="请填写最多购买数量"
						:rules="[{ required: true, message: '' }]" />
					<van-field v-model="entity.buyNumMin" type="digit" label="最少购买" clearable placeholder="请填写最少购买数量"
						:rules="[{ required: true, message: '' }]" />
					<van-field v-model="entity.price" label="分销底价" clearable placeholder="请填写分销底价"
						:rules="[{ required: true, message: '' }]" />
					<van-field v-model="entity.priceRetail" label="销售价" clearable placeholder="请填写销售价"
						:rules="[{ required: true, message: '' }]" />
					<van-field v-model="entity.stock" type="digit" label="当天库存" clearable placeholder="请填写当天库存"
						:rules="[{ required: true, message: '' }]" />
					<div class="btns-lr van-goods-action">
						<van-button class="btn-l" type="primary" color="#be99ff" text="取消" @click="closeQx" />
						<van-button class="btn-r" type="primary" color="#7232dd" text="确认" native-type="submit" />
					</div>
				</van-form>
				<p style="padding: 10px;border-top: 1px solid #ccc;">批量设置</p>
				<van-form class="col-form" style="margin-bottom: 50px;">
					<van-field :value="value" readonly clickable label="日期选择" placeholder="日期选择(可多选)"
						@click="showCalendar = true" />
					<van-field label="设置星期">
						<template #input>
							<div style="width:100%;display: flex;justify-content: space-around;">
								<van-button size="small" style="width: 14%;" type="default" v-for="(o,index) in weeks"
									@click="checkWdate(o)" :color="weekDates.indexOf(o)> -1?'#1989fa':''">
									{{o}}
								</van-button>
							</div>
						</template>
					</van-field>
					<van-field label="指定日期">
						<template #input>
							<div style="width:100%;display: flex;flex-wrap: wrap;">
								<van-button size="small" style="width: 10%;" type="default" :disabled="ybvisb"
									v-for="o in 31" @click="checkYdate(o)"
									:color="(!ybvisb&&zdDates.indexOf(o)> -1)?'#1989fa':''">
									{{o<10?'0'+o:o}}
								</van-button>
							</div>
						</template>
					</van-field>
				</van-form>
				<van-calendar v-model="showCalendar" type="range" color="#1989fa" :show-confirm="false"
					:allow-same-day="true" :default-date="defaultDate" @confirm="onQjconfirm" />

			</div>
		</CubePage>
	</div>
</template>

<script>
	import CubePage from '../../TP/cube-page.vue'
	import * as util from '@/utils/network'
	import {
		getdiffdate
	} from '@/utils/date.js'
	export default {
		components: {
			CubePage
		},
		data() {
			return {
				poppable: false,
				showCalendar: false,
				show: false,
				qjshow: false,
				value: '',
				username: '',
				entity: {},
				rq: null,
				weeks: ['周天', '周一', '周二', '周三', '周四', '周五', '周六'],
				ybvisb: false,
				zdDates: [],
				weekDates: [],
				selAllDates: null, //选中范围的全部日期
				weekSelDates: null, //选中星期的全部日期
				defaultDate: null, //默认选中的日期
				zzDates: [], //最终日期集合
			}
		},
		created() {
			let params = this.$route.params
			console.log('params', params)
			let dedate = params.defaultDate
			let date = this.formatDate(dedate)
			this.getSkuObj(date, params.sku)
			this.value = `${date} - ${date}`;
			this.defaultDate = [dedate, dedate]
			this.selAllDates = []
			this.selAllDates.push(date)
			this.getDatezz()
		},
		methods: {
			async getSkuObj(date, obj) {
				console.log(obj)
				let that = this
				var url = "/addons/litestore/api.supplier/getCalendar"
				await util.get(url, {
						goods_id: obj.goods_id,
						spec_sku_id: obj.spec_sku_id,
						date: date
					},
					function(res) {
						that.entity = res
					});
			},
			//设置完成
			onCommit() {
				// this.entity.newData=true
				this.$router.push({
					name: 'pEditSku',
					params: {
						backobj: {
							entity: this.entity,
							zzdates: this.zzDates
						}
					}
				})
			},
			//区间日期选择
			onQjconfirm(date) {
				let that = this
				const [start, end] = date;
				let sdate = that.formatDate(start);
				let edate = that.formatDate(end);
				let arrys = getdiffdate(sdate, edate);
				that.selAllDates = arrys
				that.getDatezz()
				this.showCalendar = false
				this.value = `${sdate} - ${edate}`;
			},
			// 选中星期
			checkWdate(o) {
				let that = this
				that.ybvisb = false;
				that.zdDates = []
				let index = that.weekDates.indexOf(o);
				if (index == -1) {
					//不存在
					that.weekDates.push(o)
				} else {
					that.weekDates.splice(index, 1);
				}
				if (that.weekDates.length > 0) {
					that.ybvisb = true;
				}
				that.getDatezz()
			},
			// 选中指定日期
			checkYdate(o) {
				let that = this
				let index = that.zdDates.indexOf(o);
				if (index > -1) {
					that.zdDates.splice(index, 1);
				} else {
					that.zdDates.push(o)
				}
				that.getDatezz()
			},
			//获取最终日期集合
			getDatezz() {
				let that = this
				let eds = []
				if (that.selAllDates == null || that.selAllDates.length < 1) {
					return;
				}
				//星期是否为空
				if (that.weekDates == null || that.weekDates.length < 1) {
					//指定日期是否为空
					if (that.zdDates == null || that.zdDates.length < 1) {
						eds = that.selAllDates
					} else {
						//指定日期不为空
						that.selAllDates.map((item) => {
							let sday = item.split('-')[2];
							for (var i = 0; i < that.zdDates.length; i++) {
								if (sday == that.zdDates[i]) {
									eds.push(item)
								}
							}
						})
					}
				} else {
					that.selAllDates.map((item) => {
						let myDate = new Date(item);
						let wk = myDate.getDay();
						for (var i = 0; i < that.weekDates.length; i++) {
							if (that.weeks[wk] == that.weekDates[i]) {
								eds.push(item)
							}
						}
					})
				}
				that.zzDates = eds
				console.log('最终日期', that.zzDates)
			},
			formatDate(date) {
				let m = (date.getMonth() + 1) * 1 > 9 ? (date.getMonth() + 1) * 1 : ('0' + (date.getMonth() + 1) * 1)
				let d = date.getDate() > 9 ? date.getDate() : '0' + date.getDate()
				return `${date.getFullYear()}-${m}-${d}`;
			},
			closeQx() {
				console.log('取消')
				this.$router.back()
			},
		}
	}
</script>
<style type="text/css" lang="less" scoped>
	.btns-lr {
		z-index: 2000;

		.btn-l,
		.btn-r {
			flex: 1;
		}

		.btn-l {
			margin-left: 5px;
			border-top-left-radius: 999px;
			border-bottom-left-radius: 999px;
		}

		.btn-r {
			margin-right: 5px;
			border-top-right-radius: 999px;
			border-bottom-right-radius: 999px;
		}
	}

	.col-form {
		padding: 0 !important;

		.van-cell {
			flex-direction: column;
		}
	}

	.qqpages {
		height: calc(100vh - 44px);
		padding: 8px 8px 25px 8px;
		box-sizing: border-box;
		background-color: #f4f4f4;

		.btns {
			padding: 10px 0;
			display: flex;
			justify-content: center;

			.van-button {
				margin: 0 10px;
			}
		}
	}
</style>
